const DEFAULT_PROXY_URL = '/pwa_demo/ark-proxy.php';

function getProxyUrl() {
  return process.env.REACT_APP_ARK_PROXY_URL || DEFAULT_PROXY_URL;
}

async function callArkProxy({ endpoint, apiKey, body, method = 'POST' }) {
  const response = await fetch(getProxyUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Ark-Endpoint': endpoint,
      'X-Ark-Method': method,
    },
    body: JSON.stringify({
      ...body,
      ark_api_key: apiKey,
    }),
  });

  const text = await response.text();

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(`Proxy returned non-JSON response: ${text}`);
  }

  if (!response.ok) {
    const message =
      data?.error ||
      data?.message ||
      `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export async function generateImage({ apiKey, ...promptData }) {
  return callArkProxy({
    endpoint: '/api/v3/images/generations',
    apiKey,
    body: promptData,
  });
}

export async function generateVideo({ apiKey, ...body }) {
  return callArkProxy({
    endpoint: '/api/v3/contents/generations/tasks',
    apiKey,
    body,
  });
}

export async function getVideoTask({
  apiKey,
  taskId,
}) {
  return callArkProxy({
    endpoint: `/api/v3/contents/generations/tasks/${taskId}`,
    apiKey,
    body: {},
    method: 'GET',
  });
}

export async function pollVideoTask({
  apiKey,
  taskId,
  onProgress,
  intervalMs = 5000,
  maxAttempts = 120,
}) {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const result = await getVideoTask({ apiKey, taskId });

    if (onProgress) {
      onProgress(result);
    }

    const status =
      result?.status ||
      result?.data?.status ||
      result?.task?.status;

    if (status === 'succeeded' || status === 'success' || status === 'completed') {
      return result;
    }

    if (status === 'failed' || status === 'error' || status === 'cancelled') {
      throw new Error(`Video generation failed with status: ${status}`);
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  throw new Error('Polling timed out before the video task completed.');
}